import React from "react";
import CreatSelectElements from "./SelectOptions";
import Exercise from "./Workout";
function WorkoutList(prop) {
  const [exercises, setExercises] = React.useState([]);
  let filteredExercises = [];
  //Should be a state
  let exercisesToShow;
  function displaySearchResults() {
    exercisesToShow = [];
    return prop.newWorkOut.filter((workout) => {
      if (prop.partOfBody && prop.muscleTarget) {
        return prop.partOfBody === workout.bodyPart;
      } else if (prop.partOfBody) {
        return prop.partOfBody === workout.bodyPart;
      } else if (prop.muscleTarget) {
        return prop.muscleTarget === workout.target;
      } else {
        return <p>Please select a body part you want to train</p>;
      }
    });
  }
  //if we have work out go to check filter options
  //if bodyPart and target are selected show results
  //or if one of them selected show the selected one
  //search Button will pass the results to be displayed
  if (prop.newWorkOut) {
    filteredExercises = displaySearchResults();
  }
  function handelDisplayResults() {
    if (filteredExercises.length > 6) {
      for (let i = 0; i < 9; i++) {
        exercisesToShow.push(filteredExercises[i]);
      }
    } else {
      for (let i = 0; i < filteredExercises.length; i++) {
        exercisesToShow.push(filteredExercises[i]);
      }
    }
    setExercises(exercisesToShow);
  }

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="my-2">
        <div className="selectLists flex justify-center items-center flex-wrap">
          <CreatSelectElements {...prop} />
        </div>
        <div className="displayWorkout flex justify-center">
          <button
            className="bg-green-500 hover:bg-gray-100 hover:text-green-500 text-white grow-0 font-bold px-8 border rounded shadow m-2 py-2"
            onClick={handelDisplayResults}
          >
            Start
          </button>
        </div>
      </div>
      <section className="flex flex-wrap justify-center items-center">
        {exercises ? (
          exercises.map((exe) => <Exercise key={exe.id} exercise={exe} />)
        ) : (
          <p>Warming up Exercises!</p>
        )}
      </section>
    </div>
  );
}

export default WorkoutList;
